const H5_CACHE_STORAGE_KEY = 'H5_CACHE_STORAGE'

function Cache() {
  try {
    this.data = JSON.parse(localStorage.getItem(H5_CACHE_STORAGE_KEY)) || {}
    this.noStorageData = {}
  } catch (error) {
    this.data = {}
  }
}

/**
 * 向缓存中塞值
 * @param key 字段key
 * @param value 字段值
 */
Cache.prototype.set = function(key, value, config = {}) {
  // 将数据在缓存中保存一份
  if (config.noStorage) {
    this.noStorageData[key] = value
  } else {
    this.data[key] = value
    localStorage.setItem(H5_CACHE_STORAGE_KEY, JSON.stringify(this.data))
  }
}

/**
 * 从缓存中获取值
 * @param key 字段key
 * @param defaultKey 没取到值的默认值
 */
Cache.prototype.get = function(key, defaultValue) {
  return this.data[key] || this.noStorageData[key] || defaultValue
}

/**
 * 将值从缓存中移除
 * @param key 字段key
 */
Cache.prototype.remove = function(key) {
  // 删除字段
  delete this.data[key]
  // 将数据在缓存中保存一份
  localStorage.setItem(H5_CACHE_STORAGE_KEY, JSON.stringify(this.data))
}

export default new Cache()



// WEBPACK FOOTER //
// ./src/utils/cache.js